export const SectionHeading = ({ index, eyebrow, title, body, align = "left", className = "" }) => (
  <div className={`${align === "center" ? "mx-auto text-center" : ""} max-w-3xl ${className}`}>
    <div className={`flex items-center gap-3 ${align === "center" ? "justify-center" : ""}`}>
      {index && <span className="font-mono text-xs text-[var(--olive-2)]">{index}</span>}
      {index && <span className="h-px w-8 bg-[var(--olive)]/60" />}
      <span className="eyebrow">{eyebrow}</span>
    </div>
    <h2 className="font-display mt-5 text-4xl leading-[1.05] text-[var(--ink)] sm:text-5xl lg:text-[3.6rem]">
      {title}
    </h2>
    {body && <p className="mt-6 max-w-2xl text-base leading-relaxed text-[var(--ink-2)] md:text-lg">{body}</p>}
  </div>
);
